import SinglePointView from 'components/Reward/LoyaltyPromo/SinglePointView/SinglePointView';
import withGlobalModals from 'hocs/withGlobalModals';

const connectedSinglePointView = withGlobalModals(SinglePointView);

export default connectedSinglePointView;
